<template>
    <div id="wrapper" class="info-table">
        <!--======================================================
                        Header
                ======================================================-->
        <pages-header></pages-header>

        <!--======================================================
                        Main Content
                ======================================================-->
        <div class="mainContainer">
            <div class="content">
                <div class="container-fluid">
                    <ul class="nav nav-tabs" id="infoTab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="01-tab" @click="selectTab(0)" data-toggle="tab" href="#tab01" role="tab" aria-controls="01" aria-selected="true">
                                <span class="day">{{selectedDate}}</span>
                                <span class="reys">{{trips.length}} {{i18n('reys')}} </span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="02-tab" @click="selectTab(1)" data-toggle="tab" href="#tab02" role="tab" aria-controls="02" aria-selected="false">
                                <span class="day">{{nextDay}}</span>
                                <span class="reys">{{nextDayTrips.length}} {{i18n('reys')}}</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="03-tab" @click="selectTab(2)" data-toggle="tab" href="#tab03" role="tab" aria-controls="03" aria-selected="false">
                                <span class="day">{{afterNextDay}}</span>
                                <span class="reys">{{afterNextDayTrips.length}} {{i18n('reys')}}</span>
                            </a>
                        </li>
                    </ul>
                    <div class="tab-content" id="infoTabContent">
                        <div class="tab-pane fade show active" id="tab01" role="tabpanel" aria-labelledby="01-tab">
                            <trips-list
                                :trips="trips"
                                :selected-trip="selectedTrip"
                                :loading-state="todayLoadingState"
                                @selectTrip="selectTrip"
                                @next="next"
                            ></trips-list>
                        </div>
                        <div class="tab-pane fade" id="tab02" role="tabpanel" aria-labelledby="02-tab">
                            <trips-list
                                :trips="nextDayTrips"
                                :selected-trip="selectedTrip"
                                :loading-state="nextLoadingState"
                                @selectTrip="selectTrip"
                                @next="next"
                            ></trips-list>
                        </div>
                        <div class="tab-pane fade" id="tab03" role="tabpanel" aria-labelledby="03-tab">
                            <trips-list
                                :trips="afterNextDayTrips"
                                :selected-trip="selectedTrip"
                                :loading-state="afterNextLoadingState"
                                @selectTrip="selectTrip"
                                @next="next"
                            ></trips-list>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div><!--/wrapper-->
</template>

<script>
    import PagesHeader from "../components/PagesHeader";
    import TripsList from '../components/TripsList';

    export default {
        components: {PagesHeader, TripsList},
        data() {
            return {
                trips: [],
                nextDayTrips: [],
                afterNextDayTrips: [],
                selectedTrip: {},
                selectedDate: '',
                nextDay: '',
                afterNextDay: '',
                todayLoadingState: false,
                nextLoadingState: false,
                afterNextLoadingState: false,
            }
        },
        created() {
            this.$store.state.selectedSeats = [];
            let store = this.$store.state;
            if (!store.date.date) {
                store.date.date = this.$moment(this.$route.params.date).format('YYYY-MM-DD');
            }
            store.from.id = this.$route.params.from;
            store.to.id = this.$route.params.to;
            this.todayLoadingState = true;
            this.nextLoadingState = true;
            this.afterNextLoadingState = true;
            this.getTrips(store.date.date, store.from.id, store.to.id)
                .then(res => {
                    this.trips = res;
                    this.todayLoadingState = false;
                })
                .catch(() => {
                    this.todayLoadingState = false;
                });
            this.selectedDate = this.$moment(this.$store.state.date.date).format('D MMMM');
            let day = this.$moment(this.$store.state.date.date).add(1, 'days');
            this.nextDay = day.format('D MMMM');
            let day2 = this.$moment(this.$store.state.date.date).add(2, 'days');
            this.afterNextDay = day2.format('D MMMM');

            setTimeout(() => {
                this.getTrips(day.format('YYYY-MM-DD'), store.from.id, store.to.id)
                    .then(res => {
                        this.nextDayTrips = res;
                        this.nextLoadingState = false;
                    })
                    .catch(() => {
                        this.nextLoadingState = false;
                    });
            }, 3000);
            setTimeout(() => {
                this.getTrips(day2.format('YYYY-MM-DD'), store.from.id, store.to.id)
                    .then(res => {
                        this.afterNextDayTrips = res;
                        this.afterNextLoadingState = false;
                    })
                    .catch(() => {
                        this.afterNextLoadingState = false;
                    });
            }, 5000);

        },
        mounted() {

        },
        methods: {
            selectTab(day) {
                this.$store.commit("setSelectedDateOnChangeTab", day);
            },
            selectTrip(trip) {
                this.selectedTrip = trip;
                let stations = trip.name.split('-');
                trip.from = stations[0];
                trip.to = stations[1];
                this.$store.state.selectedTrip = trip;
            },
            getTrips(date, from, to) {
                return new Promise((resolve, reject) => {
                    axios.post('/infokiosk/trips', {
                        date: date,
                        from: from,
                        to: to
                    })
                        .then(res => {
                            resolve(res.data.data);
                        })
                        .catch(err => {
                            reject(err);
                        })
                })
            },
            next() {
                this.$router.push({
                    name: 'web-tickets',
                    params: {
                        from: this.$route.params.from,
                        to: this.$route.params.to,
                        date: this.$route.params.date,
                        id: this.selectedTrip.id
                    }
                });
            }
        },
        filters: {
            asTime(val) {
                let hour = Math.floor(val / 60 / 60);
                let min = Math.floor(val / 60 % 60);
                return hour + ' ч. ' + min + ' м.'
                // return val
            },
        }
    }
</script>

<style scoped>

</style>
